import { render } from "./CaseMenuItemSelect.vue?vue&type=template&id=bf4767fa&scoped=true"
import script from "./CaseMenuItemSelect.vue?vue&type=script&lang=js"
export * from "./CaseMenuItemSelect.vue?vue&type=script&lang=js"

import "./CaseMenuItemSelect.vue?vue&type=style&index=0&id=bf4767fa&scoped=true&lang=scss"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf4767fa"]])

export default __exports__